import { render, staticRenderFns } from "./RecuImpot.vue?vue&type=template&id=491defe2"
import script from "./RecuImpot.vue?vue&type=script&lang=js"
export * from "./RecuImpot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports